var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"https://ljtc.tcrc.com.cn/webroot/decision/view/report?viewlet=%25E5%25AE%2589%25E7%25BD%25AE%25E5%25B0%25B1%25E4%25B8%259A.cpt&ref_t=design&ref_c=186e118a-1a02-4f5a-804b-92aebaec5776","id":"mobsf","width":"100%","height":"100%","scrolling":"no","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }